import React from 'react';
import { Popover } from '@material-ui/core';
import DatePickerComponent from './DatePickerComponent';
import moment from 'moment';
import { downloadPackagesCsvReport, downloadProductCsvReport } from '../../store/actions/incoming';
import { toast } from "react-toastify";
import PropTypes from 'prop-types';

/* istanbul ignore next */
const ReturnsDownloads = (props) => {
    const {returnType} = props;
    const [formData, setFormData] = React.useState({
        fromDate: moment().subtract(7, 'days').toDate(),
        toDate: new Date()
    });
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setFormData({
            fromDate: moment().subtract(7, 'days').toDate(),
            toDate: new Date()
        });
    };

    const open = Boolean(anchorEl);
    const id = open ? 'download-popover' : undefined;

    const handleDateChange = (date, fieldName) => {
        let dateSelected = moment(date).utc(true).format();
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: dateSelected
        }));
    };

    const handleDownload = async() => {
        if (moment(formData.fromDate).format('YYYY-MM-DDT00:00:00') > moment(formData.toDate).format('YYYY-MM-DDT00:00:00')) {
            toast.error("From date cannot be later than To date");
            return;
        }
        if (returnType === "RETURN_PRODUCTS") {
            let payloadData = {
                processingDateFrom: moment(formData.fromDate).format('YYYY-MM-DDT00:00:00'),
                processingDateTo: moment(formData.toDate).format('YYYY-MM-DDT00:00:00'),
                pageIndex: 1,
                pageSize: 30,
                sortColumn: "",
                searchKeywords: "",
                sellerIdList: [],
                companyIdList: [],
                showFilter: true,
                searchTxt: "",
                sortOrder: "DESCENDING",
                showSearch: true,
                companySellerId: 0,
                isSuperAdmin: true,
                warehouseList: [],
                conditionList: [],
            };
            let downloadRes = await downloadProductCsvReport(payloadData);
            if (downloadRes?.data?.Status === 200) {
                toast.success(downloadRes?.data?.Entity);
            } else {
                toast.error(downloadRes?.data?.Entity);
            }
        }
        
        if (returnType === "RETURN_PACKAGES") {
            let data = {
                fromDate: moment(formData.fromDate).format('YYYY-MM-DDT00:00:00'),
                toDate: moment(formData.toDate).format('YYYY-MM-DDT00:00:00'),
                sortColumn: "",
                searchKeywords: "",
                packageTypes: [],
                sources: [],
                sellerIdList: [],
                companyIdList: [],
                carriers: [],
                searchTxt: "",
                sortOrder: "DESCENDING",
                companySellerId: 0,
            };
            let downloadRes = await downloadPackagesCsvReport(data);
            if (downloadRes?.data?.Status === 200) {
                toast.success(downloadRes?.data?.Entity);
            } else {
                toast.error(downloadRes?.data?.Entity);
            }
        }
        handleClose();
    };

    return (
        <div className='selectYear'>
            <button className='btn cus-seconday-bg-btn top-btn' aria-describedby={id} onClick={handleClick}>
                Download CSV 
            </button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <div className='returnsExportDiv'>
                    <div className='returnsExportWrapper'>
                        <div className='mr-2 dateLabel'>
                            <div className='alignLeft'>{returnType === "RETURN_PRODUCTS" ? "Processing From" : "From"}</div>
                            <DatePickerComponent
                                dateField={formData?.fromDate}
                                fieldName={'fromDate'}
                                handleDateChange={handleDateChange} 
                            />
                        </div>
                        <div className='dateLabel'>
                            <div className='alignLeft'>{returnType === "RETURN_PRODUCTS" ? "Processing To" : "To"}</div>
                            <DatePickerComponent 
                                dateField={formData?.toDate}
                                fieldName={'toDate'}
                                handleDateChange={handleDateChange}
                            />
                        </div>
                    </div>
                    <button className='btn cus-seconday-bg-btn' onClick={handleDownload}>
                        Download
                    </button>
                </div>
            </Popover>
        </div>
    );
}

ReturnsDownloads.propTypes = {
    returnType: PropTypes.string.isRequired
}
 
export default ReturnsDownloads;